module.exports = __webpack_public_path__ + "static/img/icon_info_02.21518596.png";